import { SlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { CSSProperties, memo } from "react";
import { RedoButton } from "../../arbiter-components/buttons/redo-button";
import { Flex } from "../../flex";
import { SlideInPanel } from "../../slide-in-panel";
import { Header, Text } from "../../text";

export interface RescuePanelContentProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  buttonText: string;
  buttonSubtext?: string;
  placement: SlideInPanelAnchorLocation;
  buttonStyles: CSSProperties;
  buttonPending?: boolean;
  onButtonClick?: () => void;
  readonlyPreview?: boolean;
}

export const RescuePanelContent = memo(function RescuePanelContent({
  open,
  onClose,
  title,
  description,
  buttonText,
  buttonSubtext,
  placement,
  buttonStyles,
  buttonPending = false,
  onButtonClick,
  readonlyPreview = false,
}: RescuePanelContentProps) {
  return (
    <SlideInPanel
      anchorLocation={placement}
      handleCloseClick={onClose}
      open={open}
      readonlyPreview={readonlyPreview}
    >
      <Flex align="flex-start" dir="column" gap="xl" w="full">
        <Flex align="flex-start" dir="column" gap="xl">
          <Header fontSize="sm" fontWeight="bold" textColor="primary">
            {title}
          </Header>
          <Text fontSize="md" fontWeight="regular" textColor="primary">
            {description}
          </Text>
        </Flex>

        <Flex dir="column" gap="md" w="full">
          <Flex align="center" gap="xl" w="full">
            <Flex flex={1}>
              <RedoButton
                dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={
                  buttonStyles
                }
                flexGrow={1}
                hierarchy="primary"
                onClick={onButtonClick}
                pending={buttonPending}
                size="xl"
                text={buttonText}
              />
            </Flex>
          </Flex>
          {buttonSubtext && (
            <Flex justify="center" w="full">
              <Text fontSize="xs" fontWeight="regular" textColor="secondary">
                {buttonSubtext}
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </SlideInPanel>
  );
});
